import { ApiFragment, Comparable, Trackable } from '@stylehaven/components';

export interface IRelationItem {
    fragment: ApiFragment;
    relationType: string;
}

export class RelationItem implements IRelationItem, Comparable, Trackable {
    readonly fragment: ApiFragment;
    readonly relationType: string;

    constructor({ fragment, relationType }: IRelationItem) {
        this.fragment = fragment;
        this.relationType = relationType;
    }

    equals(other: any): boolean {
        if (!(other instanceof RelationItem)) {
            return false;
        }

        return this.fragment === other.fragment && this.relationType === other.relationType;
    }

    trackBy(): string {
        return this.fragment.getFragmentId() + this.relationType;
    }
}
